module.exports = __webpack_public_path__ + "static/social-popular-posts-a1a128d1e18f02a32dd0c600a243fc9f.png";